"use client";

import React from "react";
var __jsx = React.createElement;
import { createContext, useContext, useState } from "react";
import { MobileRegistry } from "../registry";
const ForwardNodeContext = /*#__PURE__*/createContext(undefined);
export const ForwardNodeProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    0: currentNode,
    1: setCurrentNode
  } = useState(null);
  const setNode = node => {
    const Component = MobileRegistry.components[node];
    setCurrentNode(__jsx(Component, null));
  };
  return __jsx(ForwardNodeContext.Provider, {
    value: {
      currentNode,
      setNode
    }
  }, children);
};
export const useForwardNode = () => {
  const context = useContext(ForwardNodeContext);
  if (context === undefined) {
    throw new Error('useForwardNode must be used within a ForwardNodeProvider');
  }
  return context;
};